import {Enum} from './base/base.enum';

export class StatusEnum extends Enum {
    protected static LABEL_KEY_BASE: string = 'ENUMS.STATUS';

    public static readonly ACTIVE = new StatusEnum('ACTIVE');
    public static readonly INACTIVE = new StatusEnum('INACTIVE');
}
